import useTableHeader from 'hooks/table/useTableHeader';
import useCommonStore from 'store/useCommonStore';
import React from 'react';
import styled, { css } from 'styled-components';
import { SectionHeaderRow } from 'styles/styled-components/section';

const TableHeader = ({ sticky_top }: { sticky_top?: string }) => {
	const { header } = useCommonStore();
	const table_header_mapper = useTableHeader();

	return (
		<TableHeaderRow _padding="17.5px 32px" sticky_top={sticky_top}>
			{header.map((item, idx) =>
				table_header_mapper[item.type](
					item,
					idx,
					idx !== 0 ? header[idx - 1] : undefined,
				),
			)}
		</TableHeaderRow>
	);
};

const TableHeaderRow = styled(SectionHeaderRow)<{ sticky_top?: string }>`
	width: max-content;
	min-width: 100%;
	height: 56px;
	padding: 0 29px;
	${({ sticky_top }) =>
		sticky_top
			? css`
					position: sticky;
					top: ${sticky_top};
					z-index: 9;
			  `
			: css`
					position: unset;
			  `};

	${({ theme }) => theme.common.flexStart};
`;

export default React.memo(TableHeader);
